import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import CardHeader from "../components/CardHeader/CardHeader";
import styled from "styled-components";
import theme from "../theme/theme";
import CustomButton from "../components/CustomButton/CustomButton";
import { useHistory, useParams } from "react-router-dom";
import {
  establishSSOConnectionAction,
  resetEstablishSSOConnection,
  resetVerificationForm,
  getTemporaryCredentials,
} from "../redux/actions";
import firstImg from "./../assets/1.png";
import secondImg from "./../assets/2.png";
import thirdImg from "./../assets/3.png";
import LoadingBar from "../components/LoadingBar/LoadingBar";
import { SET_LOADING } from "../redux/action-types";
import Header from "../components/Header";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ResetInstructionStep from "../components/ResetInstructionStep";
import ErrorPopUp from "../components/ErrorPopUp/ErrorPopUp";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

const BodyWrapper = styled.div`
  width: 100%;
  min-height: calc(100vh - 75px);
  box-sizing: border-box;
  padding: 30px 0;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  @media (max-width: 480px) {
    min-height: calc(100vh - 65px);
  }

  .headerMessage {
    font-weight: 700;
    font-size: 32px;
    color: ${theme.colors.primaryStrong2X};
  }

  .title {
    color: #48c8f4;
  }

  .buttonContainer {
    width: 40%;
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    @media (max-width: 480px) {
      width: 90%;
    }
  }

  .checkIcon {
    display: flex;
    align-items: baseline;
    flex-wrap: nowrap;
    flex-direction: row;
  }

  .imgCheck {
    margin-right: 1em;
  }

  .numberContainer {
    display: flex;
    align-items: center;
  }

  .numberImg {
    margin-right: 1em;
  }

  .helpButton {
    color: white;
    padding: 15px 40px;
    border: none;
    border-radius: 5px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    background-color: #48c8f4;
    @media (max-width: 480px) {
      padding: 10px 20px;
    }
  }

  .buttonBackContainer {
    margin-top: 2em;
    margin-right: 2em;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    @media (max-width: 480px) {
      margin: 0 7px 0 0;
    }
  }

  .notificationContainer {
    margin-top: 1em;
    margin-right: 2em;
    @media (max-width: 480px) {
      margin: 0 7px 0 0;
    }
  }

  @media (max-width: 480px) {
    .checkIcon {
      display: flex;
      align-items: baseline;
      flex-wrap: nowrap;
      flex-direction: column;
    }
  }
`;

const CardContainer = styled.section`
  display: flex;
  box-sizing: border-box;
  align-items: center;
  border-radius: 10px;
  padding: 30px;
  width: 40%;
  background-color: #fff;
  display: flex;
  flex-direction: column;

  @media (max-width: 480px) {
    width: 90%;
  }

  & h2 {
    font-weight: 700;
    font-size: 32px;
    color: ${theme.colors.primaryStrong2X};
    margin: 0;

    @media (max-width: 480px) {
      font-size: 28px;
    }
  }

  & p {
    font-size: 13px;
    text-align: justify;
    margin: 15px 0;
  }

  .information-container {
    display: flex;
    align-items: center;
    margin: 20px 0;
    & > p {
      font-style: italic;
      margin: 0;
      word-wrap: break-word;
    }
  }

  .info-logo {
    min-height: 26px;
    min-width: 26px;
    border: 2px dashed ${theme.colors.primaryStrong2X};
    border-radius: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;

    & p {
      font-weight: 700;
      font-size: 20px;
      color: ${theme.colors.primaryStrong2X};
      margin: 0;
    }
  }

  .more-info {
    font-style: italic;
    margin: 0;
    word-wrap: break-word;

    & a {
      text-decoration: none;
      color: ${theme.colors.primaryOld};
    }
  }

  .errorText {
    min-width: 300px;
    font-size: 16px;
    color: ${theme.colors.error};
  }
`;

const TemporaryPasswordContainer = styled.div`
  width: 40%;
  text-align: right;
  margin-top: 20px;

  .text {
    font-size: 14px;
    font-weight: 700;
  }

  .secondaryText {
    font-size: 14px;
    font-weight: 700;
    display: flex;
    justify-content: right;
    margin-top: 20px;
    margin-bottom: 15px;

    .passwordInput {
      background: none;
      width: 100px;
      margin-left: 10px;
    }

    .iconButtonsContainer {
      display: flex;
      justify-content: right;
    }

    .show-hide-copy {
      margin-left: 20px;
      color: ${theme.colors.primaryStrong2X};
      cursor: pointer;
      display: flex;

      & p {
        margin-left: 5px;
        margin-block: 0;
        margin-top: -2px;
      }
    }
  }

  @media (max-width: 480px) {
    width: 90%;
    text-align: right;
    padding: 0px 30px;

    .secondaryText {
      display: block;
    }

    .iconButtonsContainer {
      margin-top: 20px;
    }
  }
`;

const ButtonContainer = styled.div`
  width: 40%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin: 20px 0;

  & button {
    width: 30%;
    color: #fff;
    border: none;
    font-size: 12px;
    font-weight: 700;
    padding: 10px;
    background-color: ${theme.colors.primaryStrong2X};
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  & p {
    font-size: 13px;
    text-align: justify;
    margin: 5px 0;
  }

  @media (max-width: 480px) {
    width: 90%;
  }
`;

const VerificationForm = () => {
  const {
    verificationForm,
    loading,
    setGoalToLaunchPayLoad,
    establishSSOConnection,
    userAccountDetails,
    goal,
  } = useSelector((state) => state.user);
  const history = useHistory();
  const { type } = useParams();
  const [isLoaded, setIsLoaded] = useState(true);
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const [isCopyButtonNormal, setCopyButtonToNormal] = useState(true);
  const [passwordShown, setPasswordShown] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (loading) {
      setIsLoaded(false);
    }
  }, [loading]);

  useEffect(() => {
    dispatch({ type: SET_LOADING, payload: true });
    setIsLoaded(false);
    if (verificationForm && userAccountDetails) {
      (async () => {
        if (goal.id) {
          const credentials = await dispatch(getTemporaryCredentials(goal.id));
          dispatch({ type: SET_LOADING, payload: false });
          if (credentials?.username) {
            setPassword(credentials?.password);
          } else {
            setError(true);
          }
        } else {
          setError(true);
        }
      })();
    } else if (!goal.id) {
      dispatch({ type: SET_LOADING, payload: false });
    }
  }, [dispatch, goal, userAccountDetails, verificationForm, setError]);

  const handleEditDetails = () => {
    history.push(`/${type}-form`);
  };

  const handleHelp = () => {
    alert("help");
  };

  const handleContinue = () => {
    dispatch(establishSSOConnectionAction(setGoalToLaunchPayLoad?.goalId));
  };

  useEffect(() => {
    if (establishSSOConnection?.SIGNED_URL) {
      window.open(establishSSOConnection?.SIGNED_URL, "_blank");
      dispatch(resetEstablishSSOConnection());
      dispatch(resetVerificationForm());
      history.push("/temporary-password");
    }
  }, [dispatch, establishSSOConnection, history]);

  return (
    <>
      {(loading || !isLoaded) && (
        <LoadingBar isLoading={loading} setIsLoaded={setIsLoaded} />
      )}
      {!goal.id && <ErrorPopUp />}
      <Header />
      <BodyWrapper>
        {verificationForm?.isError === undefined ? (
          <></>
        ) : (
          <>
            {verificationForm?.isError === true ? (
              <>
                <CardContainer>
                  <CardHeader text={"Oops!"} />
                  <p className="errorText">{verificationForm?.errorMessage}</p>
                </CardContainer>
                <div className="buttonContainer">
                  <button className="helpButton" onClick={handleHelp}>
                    HELP
                  </button>
                  <CustomButton
                    text="EDIT DETAILS"
                    nextLogo
                    onClick={handleEditDetails}
                  />
                </div>
              </>
            ) : (
              <>
                <CardContainer>
                  <h2>Let's set up your investment account</h2>
                  <p>
                    (This is an interactive Brokers LLC account protected by the
                    Securities Investor Protection Coporation ("SIPC"), where
                    your money is held so Tactive can provide your customized
                    trading signals.*)
                  </p>
                  <ResetInstructionStep
                    img={firstImg}
                    text="Update your temporary password"
                  />
                  <ResetInstructionStep
                    img={secondImg}
                    text="Open your account"
                  />
                  <ResetInstructionStep
                    img={thirdImg}
                    text="Fund your account"
                  />

                  <div className="information-container">
                    <div className="info-logo">
                      <p>i</p>
                    </div>
                    <p>
                      Incomplete applications can be continued at any time from
                      the Manage tab within your Tactive dashboard
                    </p>
                  </div>
                  <p className="more-info">
                    *click
                    <a
                      href="https://www.interactivebrokers.com/en/index.php?f=2334&p=acc&conf=am"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {" "}
                      here{" "}
                    </a>
                    for more information about Interactive Brokers and SIPC
                  </p>
                </CardContainer>
                <TemporaryPasswordContainer>
                  <div className="text">
                    Copy your temporary password below before continuing.
                  </div>
                  <div className="secondaryText">
                    <div>
                      <b>Temporary Password:</b>{" "}
                      <input
                        className="passwordInput"
                        type={passwordShown ? "text" : "password"}
                        value={password}
                      />
                    </div>
                    <div className="iconButtonsContainer">
                      <div
                        className="show-hide-copy"
                        onClick={() => setPasswordShown((prev) => !prev)}
                      >
                        {passwordShown ? (
                          <VisibilityOffIcon
                            fontSize="12px"
                            sx={{ cursor: "pointer" }}
                          />
                        ) : (
                          <RemoveRedEyeIcon
                            fontSize="12px"
                            sx={{ cursor: "pointer" }}
                          />
                        )}

                        <p>{passwordShown ? "Hide" : "Show"} </p>
                      </div>
                      <div
                        className="show-hide-copy"
                        style={{
                          color: isCopyButtonNormal
                            ? theme.colors.primaryStrong2X
                            : "gray",
                        }}
                        onClick={() => {
                          if (!isCopyButtonNormal) return;
                          navigator.clipboard.writeText(password);
                          setCopyButtonToNormal(false);
                          setTimeout(() => {
                            setCopyButtonToNormal(true);
                          }, 1000);
                        }}
                      >
                        <ContentCopyIcon
                          fontSize="12px"
                          sx={{ cursor: "pointer" }}
                        />
                        <p>{isCopyButtonNormal ? "Copy" : "Copied"}</p>
                      </div>
                    </div>
                  </div>
                </TemporaryPasswordContainer>
                <ButtonContainer>
                  <button onClick={handleContinue}>
                    CONTINUE <ArrowForwardIosIcon fontSize="14px" />
                  </button>
                  <p> *This will launch a new tab</p>
                </ButtonContainer>
              </>
            )}
          </>
        )}
      </BodyWrapper>
    </>
  );
};

export default VerificationForm;
